import React from 'react';
import {useTranslation} from "react-i18next";
import {Flex} from "antd";
import {BriefType} from "../index";
import BriefDescriptionItem from "./BriefDescriptionItem";
import {Product} from "../../../../api/types";
import dayjs from "dayjs";

interface BriefDataProps {
  brief: BriefType,
}

export default function BriefData({brief}: BriefDataProps) {
  const {t} = useTranslation()

  return (
    <Flex vertical gap={'middle'}>
      {brief.products[0].company && brief.products[0].company.pool && brief.products[0].company.pool.name &&
        <BriefDescriptionItem title={t('brief.pool')} value={brief.products[0].company.pool.name} />
      }

      {brief.products[0].company && brief.products[0].company && brief.products[0].company.name &&
        <BriefDescriptionItem title={t('brief.company')} value={brief.products[0].company.name} />
      }

      {brief.products.length > 0 &&
        <BriefDescriptionItem title={t('brief.product')} value={brief.products.map((product: Product) => product.name).join(', ')} />
      }

      {brief.kpi &&
        <BriefDescriptionItem title={t('brief.kpi')} value={brief.kpi.name} />
      }

      {brief.modelType &&
        <BriefDescriptionItem title={t('brief.modelType')} value={brief.modelType.name} />
      }

      <BriefDescriptionItem title={t('brief.specificText')} value={brief.specificText} />
      <BriefDescriptionItem title={t('brief.seasonalityText')} value={brief.seasonalityText} />
      <BriefDescriptionItem title={t('brief.bht')} value={brief.bht} />
      <BriefDescriptionItem title={t('brief.audienceText')} value={brief.audienceText} />
      <BriefDescriptionItem title={t('brief.period')} value={`${dayjs(brief.dataDateStart).format('DD.MM.YYYY')} — ${dayjs(brief.dataDateEnd).format('DD.MM.YYYY')}`}/>
    </Flex>
  )
}
